module.exports = __webpack_public_path__ + "img/alert-icon.08e16d13.svg";